import React, { useState, useEffect } from 'react';
import { CnBox, CnAsyncSelect } from '@sto/cn-ui';
import styles from './index.module.scss';

const defaultConfigs =[
  {
    type: 'hour',
    mode: 'multiple',
    placeholder: '请选择小时(可多选)',
    hasClear: true,
    dataSource: [...Array(24)].map((_, index) => ({
      label: `${index + 1}点`,
      value: `${index + 1}`,
    })),
    style: {
      width: 180,
    }
  },
  {
    type: 'minute',
    mode: 'single',
    placeholder: '请选择分钟',
    hasClear: true,
    dataSource: [...Array(60)].map((_, index) => ({
      label: `${index}分`,
      value: `${index}`,
    })),
  },
];

/**
 * 时间选择组件
 * @param dataSource 数据源
 * @param pickConfig 选择配置
 * @returns 
 */
const CustomTimePick = ({ value: propsValue, onChange, configs = defaultConfigs }) => {
  const [value, setValue] = useState({ hour: null, minute: null });

  useEffect(() => {
    if (propsValue) {
      setValue(propsValue);
    }
  }, [propsValue]);

  const handleChange = (type: string, val: string) => {
    if (type === 'hour') {
      onChange({ ...value, hour: val });
    } else {
      onChange({ ...value, minute: val });
    }
  };

  return <CnBox direction="row" align="center" className={styles.customTimePickBox}>
  {configs.map((config, index) => (
    <CnAsyncSelect
      {...config}
      key={config.type}
      mode={config.mode}
      dataSource={config.dataSource}
      placeholder={config.placeholder}
      hasClear={config.hasClear}
      value={value[config.type]}
      onChange={(val) => handleChange(config.type, val)}
    />
  ))}
</CnBox>;
};

export default CustomTimePick;